import { inject, Injectable } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { combineLatest, Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { isNotNil } from '@malou-io/package-utils';

import { MaintenanceStore } from '#core/store/maintenance.store';
import { SessionStore } from '#core/store/session.store';

@Injectable()
export class MaintenanceGuard {
    private readonly _maintenanceStore = inject(MaintenanceStore);
    private readonly _sessionStore = inject(SessionStore);
    private readonly _router = inject(Router);

    private readonly _userEmail$ = toObservable(this._sessionStore.user).pipe(
        filter(isNotNil),
        map((infos) => infos.email)
    );

    private readonly _maintenance$ = toObservable(this._maintenanceStore.maintenance);

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
        return combineLatest([this._maintenance$, this._userEmail$]).pipe(
            map(([mode, email]) => {
                if (mode?.status === 'maintenance' && !mode?.trespass.includes(email)) {
                    this._router.navigate(['/maintenance'], { queryParams: { until: mode.until } });
                    return false;
                }
                return true;
            })
        );
    }
}
@Injectable()
export class RedirectToProductionGuard {
    private readonly _maintenanceStore = inject(MaintenanceStore);
    private readonly _sessionStore = inject(SessionStore);

    private readonly _userEmail$ = toObservable(this._sessionStore.user).pipe(
        filter(isNotNil),
        map((infos) => infos.email)
    );

    private readonly _maintenance$ = toObservable(this._maintenanceStore.maintenance);

    canActivate(_next: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
        return combineLatest([this._maintenance$, this._userEmail$]).pipe(
            map(([mode, userEmail]) => {
                if (mode?.redirect && !userEmail.includes('@malou.io') && !document.location.href.includes('localhost')) {
                    document.location.href = 'https://v2.app.malou.io';
                    return false;
                }
                return true;
            })
        );
    }
}
